import {
  ActionFunctionArgs,
  data,
  MiddlewareFunction,
  useFetcher,
  useLoaderData,
} from 'react-router';

import type { AdminLoginActionResult } from '~/common/schemas/admin';
import { FormLoading } from '~/front/components/Form/FormLoading';
import { AdminLoginForm } from '~/front/models/admin/AdminLoginForm';
import { UsersLayout } from '~/front/models/end_user/UsersLayout';
import { redirectIfAuthenticatedAdminMiddleware } from '~/server/middlewares/auth_middleware/admin_unauthenticated.server';
import { loginAction } from '~/server/models/admin_context/admin/presentation/loginAction.server';
import { logger } from '~/server/utils/logger/logger.server';
import { RECAPTCHA_ENABLED } from '~/server/utils/verify_recaptcha.server';

export const middleware: MiddlewareFunction[] = [
  redirectIfAuthenticatedAdminMiddleware,
];

enum Actions {
  LOGIN = 'login',
}

export const action = async ({ request }: ActionFunctionArgs) => {
  const formData = await request.formData();
  const intent = formData.get('intent');
  switch (intent) {
    case Actions.LOGIN:
      return loginAction({ request, formData });
    default:
      throw new Response(`Invalid intent "${intent}"`, { status: 400 });
  }
};

export const loader = async () => {
  try {
    return data({
      recaptcha_enabled: RECAPTCHA_ENABLED,
    });
  } catch (error) {
    if (error instanceof Error) {
      logger.error({ error, context: { operation: 'getAdminLoginPage' } });
    }
    throw error instanceof Response
      ? error
      : new Response('データの取得に失敗しました。', { status: 500 });
  }
};

export default function Index() {
  const { recaptcha_enabled } = useLoaderData<typeof loader>();
  // useFetcher（ローディング表示・フォーム送信）は route 側で一元管理する（規約47/48）
  const loginFetcher = useFetcher<AdminLoginActionResult>();
  const loading = loginFetcher.state !== 'idle';
  return (
    <>
      <UsersLayout title="アカウントにログイン">
        <AdminLoginForm
          recaptchaEnabled={recaptcha_enabled}
          intentName={Actions.LOGIN}
          fetcher={loginFetcher}
        />
      </UsersLayout>
      {loading && <FormLoading />}
    </>
  );
}
